import {Typography} from "@mui/material";
import {styled, useTheme} from "@mui/system";
import {BoxUpper} from "./BoxUpper";
import {BoxBodyContainer, FlexBox, PriceComponent, RawBox, StyledAvatar} from "./Dashboard/styled";
import {formatPrice} from "../../helpers/dataFormat";
import shortid from "shortid";
import {useNavigate} from "react-router-dom";

const StyledBoxBodyContainer = styled(BoxBodyContainer)(({theme}) => ({
    padding: 0,
    overflow: "auto",
    height: "350px",
}));
const TotalChequeContainer = styled("div")(({theme}) => ({
    backgroundColor: theme.palette.disabled.light,
    padding: "15px 24px",
    borderBottom: `#d3d9e1 3px solid`,
}));

const Cheques = ({
                     title,
                     totalPrice,
                     cheques,
                     type,
                     count,
                 }: {
    title?: string;
    totalPrice: number;
    cheques: any[];
    type: "recieved" | "payment";
    count?: number;
}) => {
    const theme = useTheme();

    return (
        <RawBox>
            <BoxUpper title={`${title} (${count ?? ''})`}/>
            <StyledBoxBodyContainer>
                <TotalChequeContainer>
                    <PriceComponent price={`${formatPrice(totalPrice)}`} color={theme.palette.text.main}/>
                </TotalChequeContainer>
                {cheques.map((item, key) => (
                    <DebitCard type={type} item={item} key={shortid.generate()}/>
                ))}
            </StyledBoxBodyContainer>
        </RawBox>
    );
};

const DebitCardContainer = styled("div")(({theme}) => ({
    display: "grid",
    gridTemplateColumns: "16% 36% 48%",
    justifyContent: "space-between",
    height: "90px",
    padding: "15px 24px",
    border: `2px solid ${theme.palette.disabled.light}`,
}));
const DebitCardItem = styled("div")(({theme}) => ({
    width: "100%",
    height: "100%",
}));
const MiddleItem = styled(DebitCardItem)(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
}));

const PriceItem = styled(MiddleItem)(({theme}) => ({
    alignItems: "end",
}));

const DebitCard = ({item, type}: { item: any; type: "recieved" | "payment" }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const avatarImage =
        type === "recieved"
            ? "/assets/images/cheque_recieved.svg"
            : item.status === "paidReceipt"
                ? "/assets/images/cheque_cashed.svg"
                : "/assets/images/cheque_pending.svg";
    return (
        <DebitCardContainer>
            <DebitCardItem>
                <StyledAvatar outLine={false} src={avatarImage}/>
            </DebitCardItem>
            <MiddleItem>
                <PriceComponent price={`${formatPrice(item.amount)}`} color={theme.palette.text.main}/>
                <FlexBox>
                    <Typography variant="caption" color={theme.palette.text.main}>
                        {item.bank}
                    </Typography>
                    <Typography variant="caption" color={theme.palette.disabled.main}>
                        &nbsp;
                        {item.number}
                    </Typography>
                </FlexBox>
            </MiddleItem>
            <PriceItem>
                <Typography variant="caption" color={theme.palette.disabled.main}>
                    {item.dueDate}
                </Typography>
                <Typography
                    style={{cursor: "pointer"}}
                    onClick={() => window.open(`/reports/personalAccountCard?personId=${item?.Person?.id}`)}
                    color="#000"
                    className="hover:text-blue-1"
                    variant="body2"
                >
                    {type === "recieved" ? `${item?.Person?.nickName ?? ""}` : item?.payTo}
                </Typography>
            </PriceItem>
        </DebitCardContainer>
    );
};

export default Cheques;
